import React from 'react';

import { useUsers } from "../UserContext";
import { userMessages } from "../userMessages";
import { logoutUrl, registerUrl, loginUrl } from '../utils';
import { useFormatMessage } from '../../intl/intlHooks';

export const UserLoginWidgetDefault = () => {
    const { userData, fetching, fetchError } = useUsers();
    const formatMessage = useFormatMessage();
    const { firstName, orderHistoryUrl } = userData;

    return (
        <div id="auth-block" className="auth-block">
            <div className="auth-block__icon-area">
                <i className="fas fa-user user-icon" />
            </div>

            <div className="auth-block__auth-area">
                {
                    fetching && (
                        <div className="auth-block__loading-area">
                            {formatMessage(userMessages.userLoading)}
                        </div>
                    )
                }

                {fetchError && (
                    <div className="auth-block__logged-out-area">
                        <a href={loginUrl} className="btn-link auth-block__sign-in">{formatMessage(userMessages.signIn)}</a>
                        <span className="auth-block__separator"> | </span>
                        <a href={registerUrl} className="btn-link auth-block__create-account">{formatMessage(userMessages.createAccount)}</a>
                    </div>
                )}

                {!fetchError && firstName && (
                    <div className="auth-block__logged-in-area">
                        <span className="auth-block__username">{firstName}</span>
                        <span className="auth-block__separator"> | </span>
                        <a href={logoutUrl} className="btn-link auth-block__logout">{formatMessage(userMessages.logout)}</a>
                    </div>
                )}

                {!fetchError && orderHistoryUrl && (
                    <div>
                        <a href={orderHistoryUrl} target="_blank" rel="noreferrer" className="btn-link">{formatMessage(userMessages.cardOrders)}</a>
                    </div>
                )}

            </div>
        </div>
    );
};
